var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2192",
  "data-name": "Group 2192",
  transform: "translate(-803 355)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1651",
  "data-name": "Rectangle 1651",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(803 -355)",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M3.719,10.889A.609.609,0,0,0,4.754,10.6C5.2,7.452,7.606,4.9,9.292,2.4,9.759,1.711,8.5.945,8.044,1.63,6.5,3.915,4.56,5.2,3.8,7.976A13.777,13.777,0,0,0,1.439,5.952C.822,5.425-.409,6.778.214,7.311A43.382,43.382,0,0,1,3.719,10.889Z",
  transform: "translate(810.157 -349.603)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33-2",
  "data-name": "Path 33",
  d: "M2.82,8.123A.472.472,0,0,0,3.6,7.916c.337-2.235,2.026-4.12,3.3-5.9.354-.492-.46-.96-.81-.474C4.93,3.17,3.458,4.878,2.882,6.847A23.229,23.229,0,0,0,.826,4.918C.359,4.544-.31,5.2.162,5.581A31.871,31.871,0,0,1,2.82,8.123Z",
  transform: "translate(811.157 -347.784)",
  fill: "none",
  stroke: "#c7c7c7",
  strokeWidth: 1
}))));
export default __webpack_public_path__ + "static/media/adcopy-inactive.9434a8ab.svg";
export { SvgComponent as ReactComponent };